export {}

const generateGalleryId = (gallerySelector: string, galleryLinkSelector: string, postfix = "I") => {
  const galleries = document.querySelectorAll(gallerySelector)
  let galleryId = `gallery-${postfix}`

  galleries.forEach((gallery) => {
    const links = gallery.querySelectorAll(galleryLinkSelector)

    links.forEach((link) => {
      link.setAttribute("data-fancybox", galleryId)
    })
    galleryId += postfix
  })
}

generateGalleryId(".gallery", ".gallery-icon a")
generateGalleryId(".wp-block-gallery", ".blocks-gallery-item a", "W")
generateGalleryId(".g-gallery", ".i-gallery__img", "gg")
